import {
	CartItemUpsertRule,
	CartItemAvailabilityRule,
	CartStockUpdateRule,
	CartTotalsPreparationRule,
} from './interfaces';
import {
	cartItemPositiveQuantityRule,
	cartItemStoreSlugRule,
	cartItemStockRule,
	cartItemQuantityLimitRule,
	cartItemPositiveQuantityStockRule,
	cartItemsStockAvailabilityRule,
	cartItemsStockRule,
	cartItemUpsertRule,
	cartProductListStockRule,
	cartProductListAvailabilityRule,
	cartTotalsValidityRule,
	cartTotalsEligibleItemsRule,
	cartTotalsSubtotalPriceRule,
	cartUnavailableItemsRule,
} from './rules/cart-state.rules';

export class CartStateFactory {
	createItemUpsertRules(): CartItemUpsertRule[] {
		return [
			cartItemUpsertRule,
			cartItemPositiveQuantityRule,
			cartItemStoreSlugRule,
		];
	}

	createStockUpdateRules(): CartStockUpdateRule[] {
		return [
			cartProductListStockRule,
			cartProductListAvailabilityRule,
			cartItemStockRule,
			cartItemQuantityLimitRule,
			cartItemPositiveQuantityStockRule,
			cartItemsStockRule,
			cartItemsStockAvailabilityRule,
		];
	}

	createTotalsPreparationRules(): CartTotalsPreparationRule[] {
		return [
			cartTotalsValidityRule,
			cartTotalsEligibleItemsRule,
			cartTotalsSubtotalPriceRule,
		];
	}

	createAvailabilityRules(): CartItemAvailabilityRule[] {
		return [cartUnavailableItemsRule];
	}
}
